import { render, staticRenderFns } from "./allocation-tooltip.vue?vue&type=template&id=04112461&scoped=true&"
import script from "./allocation-tooltip.vue?vue&type=script&lang=js&"
export * from "./allocation-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./allocation-tooltip.vue?vue&type=style&index=0&id=04112461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04112461",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
